<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_toc_1"><span>Dedication</span></p>
<p class="P_WFP_BodyTextFirstPara__And__Centre_Alignment"><span>For Sibeol</span></p>
<p class="P_WFP_BodyTextFirstPara__And__Centre_Alignment"><span>and synchronicity</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?278a291a